//casti obce
import { fetchEntityList } from "@pasport/react-common";
import { mapApiToTownPart } from "./TownPartApi.map";

export const getTownPartList = async () => {
	return fetchEntityList(`obce`, mapApiToTownPart);
};